import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    window.onload = this.setInitialHeight;

    window.onload = setInterval(this.iframeHeight, 1000);
    window.onresize = this.iframeHeight;
  }

  setInitialHeight() {
    this.height = document.body.scrollHeight;
    window.parent.postMessage(this.height, "*");
  }

  iframeHeight() {
    if (this.height != document.body.scrollHeight) {
      this.height = document.body.scrollHeight;
      window.parent.postMessage(this.height, "*");
    }
  }
}
